module.exports = __webpack_public_path__ + "media/images/athletes/3396-243e882368740faad6388eecd9ac55ae.png";